<template>
  <div class="andon_management">
    <el-row class="andon_row" v-for="(list, i) in andonTypeDoubleList" :key="i">
      <el-col
          :span="6"
          class="andon_item"
          v-for="(item, index) in list"
          :key="index"
      >
        <el-card>
          <el-row class="andon_item_row">
            <div class="row">
              <div class="col">
                <div
                    class="andon_item_level"
                    :class="lightColors[item.status]"
                ></div>
              </div>
              <div class="col">
                <div
                    class="andon_item_level"
                    :class="lightColors[item.responded]"
                ></div>
              </div>
            </div>
          </el-row>
          <el-row class="andon_row">
            <el-button
                type="danger"
                icon="el-icon-warning"
                class="andon_button"
                @click="openDialog(item.index)"
            >
              {{ item.name }}
            </el-button>
            <el-button
                type="success"
                icon="el-icon-check"
                class="andon_button"
                @click="confirmReset(item)"
            >
              复 位
            </el-button>
          </el-row>
        </el-card>
      </el-col>
    </el-row>

    <el-dialog
        title="录入安灯信息"
        top="5vh"
        :append-to-body="true"
        :visible.sync="dialogVisible"
        width="70%"
        @closed="closeDialog"
    >
      <el-form :model="form">
        <el-form-item label="预约时间" :label-width="formLabelWidth">
          <el-date-picker
              v-model="form.startTime"
              type="datetime"
              placeholder="开始时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="安灯子类" :label-width="formLabelWidth">
          <el-select
              v-model="form.problemAndonSubtypeId"
              placeholder="选择安灯子类"
          >
            <el-option
                v-for="item in andonSubType"
                :key="item.id"
                :label="item.name"
                :value="item.id"
            ></el-option>
          </el-select>
          <span>--不选择默认无安灯子类</span>
        </el-form-item>
        <el-form-item label="工单工序" :label-width="formLabelWidth">
          <el-select v-model="form.prdPpOperationId" placeholder="选择工序">
            <el-option
                v-for="item in ppOperation"
                :key="item.id"
                :label="
                $t(item.prdPpHeaderOrderCode) +
                  '-->' +
                  $t(item.prdPpOperationSeq)
              "
                :value="item.id"
            ></el-option>
          </el-select>
          <span>--不选择默认当前工单工序</span>
        </el-form-item>
        <el-form-item label="问题描述" :label-width="formLabelWidth">
          <el-input v-model="form.problemDescription"></el-input>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth">
          <el-switch
              inactive-text="是否停机"
              v-model="form.stopWork"
          ></el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="saveAndonTask">
          提 交
        </el-button>
      </span>
    </el-dialog>

    <el-dialog
        title="复位安灯任务"
        :visible.sync="resetVisible"
        :modal="false"
        width="70%"
    >
      <el-table :data="openAndonTaskList" max-height="190px" @row-click="rowClick">
        <el-table-column width="30">
          <template slot-scope="scope">
            <el-radio
                :label="scope.row.id"
                v-model="resetItem.taskId"
            ></el-radio>
          </template>
        </el-table-column>
        <el-table-column
            label="任务编号"
            prop="id"
            width="100"
        ></el-table-column>
        <el-table-column label="创建时间" prop="createdTime"></el-table-column>
        <el-table-column
            label="描述"
            prop="problemDescription"
        ></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetVisible = false">取 消</el-button>
        <el-button type="primary" @click="resetAndonTask">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {createHelpers} from "vuex-map-fields";
import emCommonApi from "@/mixin/em/common/api";
import emWebSocketMixin from "@/mixin/em/common/webSocket";

const modelName = "sithMesAndonTask";

const {mapFields} = createHelpers({
  getterType: modelName + "/getField",
  mutationType: modelName + "/updateField"
});

export default {
  name: "andon-management",
  components: {},
  mixins: [emCommonApi, emWebSocketMixin],
  props: {ppOperationId: Number, locationId: Number},

  data: function () {
    return {
      lightColors: ["lc_white", "lc_red", "lc_yellow", "lc_green", "lc_blue"],
      light: [],
      taskStatus: [],
      dialogVisible: false,
      formLabelWidth: "80px",
      form: {
        id: "1",
        problemAndonTypeId: null,
        problemAndonSubtypeId: null,
        stopWork: null,
        mstLocationId: this.locationId,
        status: 1,
        startTime: null,
        prdPpOperationId: null,
        problemDescription: "",
        finishTime: null
      },
      andonTypeDoubleList: [],
      typeIndex: "",
      andonTypeList: [],
      andonType: 242,
      andonSubType: [],
      ppHeader: null,
      ppOperation: null,
      defaultPpOperation: {id: null, prdPpOperationSeq: null},
      ppAndonTask: null,
      lightInterval: null,
      resetVisible: false,
      resetItem: 0,
      openAndonTaskList: null,
      subscribeItem: {
        id: 'andonRespond',
        topic: 'andon/respond',
        callback: () => {
          this.getAndonTask();
        }
      },
      isConnected: false
    };
  },
  mounted() {
    this.initPage();
    this.getAndonType();
    this.getOperationInfo();
    this.getAndonTask();
    this.setLightInterval();
    this.listenToRefresh();
  },
  beforeDestroy() {
    this.clear();
    this.$webSocket.unsubscribeToPoint(this.subscribeItem.id);
  },
  computed: {...mapFields(["baseModuleUrl"])},
  methods: {
    //被动刷新
    listenToRefresh() {
      this.$webSocket.subscribeToPoint(this.subscribeItem);
    },
    initPage() {
      this.form.prdPpOperationId = this.$route.query.operation;
      this.defaultPpOperation.id = this.$route.query.operation;
      this.defaultPpOperation.prdPpHeaderOrderCode = "";
      this.defaultPpOperation.prdPpOperationSeq = "当前工单工序";
    },
    //定时扫描任务状态
    setLightInterval() {
      let index = 0;
      this.lightInterval = setInterval(() => {
        index++;
        if (!this.$webSocket.isConnected() || !this.isConnected) {
          this.getAndonTask();
          this.isConnected = this.$webSocket.isConnected();
          console.log('is not connected')
        } else if (index % 30 === 0) {
          index = 0;
          this.getAndonTask();
          console.log('per 30 times')
        }
      }, 10000);
    },
    //根据任务状态设置灯的颜色
    setLightValue() {
      let lightValue = 1;

      for (let itemType of this.andonTypeList) {
        let hasNoRespondTask = false;
        let hasTask = false;
        itemType.status = 3;
        for (let itemTask of this.ppAndonTask) {
          if (itemType.id === itemTask.problemAndonTypeId) {
            lightValue *= itemTask.stopWork ? 0 : 2;
            hasTask = true;
            itemType.taskId = itemTask.id;
            //待处理。逻辑问题
            if (1 !== itemType.status) {
              itemType.status = itemTask.stopWork ? 1 : 2;
            }
            if (1 === itemTask.status || 3 === itemTask.status) {
              itemType.responded = 0;
              hasNoRespondTask = true;
            } else if (!hasNoRespondTask && 2 === itemTask.status) {
              itemType.responded = 4;
            }
          }
        }
        if (!hasTask) {
          itemType.taskId = null;
          itemType.responded = 0;
          itemType.status = 3;
        }
      }
      this.initDoubleList();
      this.$emit("lightValueChanged", lightValue);
    },
    openDialog(index) {
      this.typeIndex = index;
      this.andonType = this.andonTypeList[index].id;
      this.dialogVisible = true;
      this.form.startTime = this.$_emApiMixin_dateFormat(new Date());
      this.form.stopWork = false;

      this.form.prdPpOperationId = this.defaultPpOperation.id;
      this.form.problemAndonTypeId = this.andonType;
      this.getAndonSubType(this.andonType);
    },
    closeDialog() {
      this.form.problemAndonTypeId = null;
      this.form.problemAndonSubtypeId = null;
      this.dialogVisible = false;
    },
    confirmReset(item) {
      const _api =
          this.$store.state.sithMesPrdPpOperation.baseModuleUrl +
          "/sithMesAndonTask/findByFilter";
      this.$_emApiMixin_post(_api, {
        statusLtFilter: 4,
        prdPpOperationIdFilter: this.ppOperationId,
        mstLocationIdFilter: this.form.mstLocationId,
        problemAndonTypeIdFilter: item.id
      }).then(data => {
        this.openAndonTaskList = data.data.list;
        this.resetItem = item;
        this.resetVisible = true;
      });
    },
    //置位灯的颜色，同时将安灯任务撤销
    resetAndonTask() {
      this.resetVisible = false;
      this.andonType = this.resetItem.id;
      this.form.id = this.resetItem.taskId;
      if (this.form.id === null) {
        this.$message({
          message: "没有可复位的安灯任务！",
          type: "warning"
        });
        return;
      }
      let url = this.baseModuleUrl + "/sithMesAndonTask/selective";
      this.form.status = 5;
      this.form.startTime = null;
      this.form.finishTime = this.$_emApiMixin_dateFormat(new Date());
      this.$store
      .dispatch("api/put", {
        url,
        entity: {
          id: this.form.id,
          status: this.form.status
        }
      })
      .then(() => {
        this.$message({
          message: "复位成功！",
          type: "success"
        });
        this.getAndonTask();
      });
    },

    saveAndonTask() {
      this.dialogVisible = false;
      this.form.id = null;
      this.form.status = 1;
      this.form.finishTime = null;
      this.form.startTime = this.$_emApiMixin_dateFormat(this.form.startTime);
      let url = this.baseModuleUrl + "/sithMesAndonTask/";
      this.$store
      .dispatch("api/put", {
        url,
        entity: this.form
      })
      .then(value => {
        this.$message({
          message: "安灯成功！",
          type: "success"
        });
        this.getAndonTask();
      });
    },
    getAndonType() {
      const _api =
          this.$store.state.sithMesPrdPpOperation.baseModuleUrl +
          "/sithMesAndonType/findByFilter";
      this.$_emApiMixin_post(_api, {
        parentIdFilter: 0,
        sortingBy: [
          {
            column: "seq",
            order: "asc"
          }
        ]
      }).then(data => {
        let index = 0;
        for (let item of data.data.list) {
          this.andonTypeList.push({
            index: index++,
            id: item.id,
            name: item.name,
            englishName: item.englishName,
            taskId: null,
            status: 3,
            responded: 0
          });
        }
        this.initDoubleList();
      });
    },
    initDoubleList() {
      let temp = [];
      temp.push(this.andonTypeList.slice(0, 4));
      temp.push(this.andonTypeList.slice(4, 8));
      this.andonTypeDoubleList = temp;
    },
    getAndonSubType(andonTypeName) {
      const _api =
          this.$store.state.sithMesPrdPpOperation.baseModuleUrl +
          "/sithMesAndonType/findByFilter";
      this.$_emApiMixin_post(_api, {
        parentIdFilter: andonTypeName
      }).then(data => {
        this.andonSubType = data.data.list;
      });
    },
    getOperationInfo() {
      const _api =
          this.$store.state.sithMesPrdPpOperation.baseModuleUrl +
          "/sithMesPrdOperationUser/findByFilter";
      this.$_emApiMixin_post(_api, {}).then(data => {
        this.ppOperation = data.data.list;
      });
    },
    getAndonTask() {
      const _api =
          this.$store.state.sithMesPrdPpOperation.baseModuleUrl +
          "/sithMesAndonTask/findByFilter";
      this.$_emApiMixin_post(_api, {
        statusLtFilter: 4,
        prdPpOperationIdFilter: this.ppOperationId,
        mstLocationIdFilter: this.form.mstLocationId
      }).then(data => {
        this.ppAndonTask = data.data.list;
        this.setLightValue();
      });
    },
    rowClick(row) {
      this.resetItem.taskId = row.id;
    },
    clear() {
      clearInterval(this.lightInterval);
    }
  }
};
</script>

<style scoped>
.andon_management {
  margin-left: 20px;
}

.andon_item {
  /*height: 200px;*/
  width: min-content;
}

.andon_item_row {
  /*height: 80%;*/
  /*margin: -20px;*/
  width: 155px;
}

.andon_item_level {
  width: 70px;
  height: 70px;
  margin: 0;
  border-radius: 50%;
  /*background: chartreuse;*/
}

.andon_button {
  width: 70px;
  height: 30px;
  padding: 0;
  font-size: 12px;
  font-weight: bold;
}

.andon_row {
  margin-top: 8px;
}

.andon_management >>> .el-card {
  width: min-content;
}

.andon_management >>> .el-card__body {
  padding: 10px;
  background-color: #f1f1f1;
}

.andon_management >>> .el-col {
  margin-left: 10px;
}

.lc_white {
  background-color: white;
}

.lc_red {
  background-color: red;
}

.lc_yellow {
  background-color: yellow;
}

.lc_green {
  background-color: #73dc73;
}

.lc_blue {
  background-color: blue;
}
</style>
